/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyNameResponseAllOfData
 */
export interface CompanyNameResponseAllOfData {
    /**
     * 企業名
     * @type {string}
     * @memberof CompanyNameResponseAllOfData
     */
    companyName: string;
}

export function CompanyNameResponseAllOfDataFromJSON(json: any): CompanyNameResponseAllOfData {
    return CompanyNameResponseAllOfDataFromJSONTyped(json, false);
}

export function CompanyNameResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyNameResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyName': json['company_name'],
    };
}

export function CompanyNameResponseAllOfDataToJSON(value?: CompanyNameResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_name': value.companyName,
    };
}

